<div class="flex flex-col min-h-0">
  <div class="px-6 pt-4 pb-2 shrink-0 max-w-7xl mx-auto w-full">
    <div class="flex justify-between items-center">
      <h1 class="text-2xl font-bold text-gray-800">{{ pageTitle }}</h1>
      <button
        type="button"
        (click)="goBack()"
        class="border border-gray-300 hover:bg-gray-50 cursor-pointer text-gray-700 px-4 py-2 rounded"
      >
        Voltar
      </button>
    </div>
  </div>

  <div class="px-6 pb-8 flex-1 overflow-y-auto">
    <div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto w-full bg-white">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
      <div class="md:col-span-8">
        <label class="block mb-1 font-medium text-gray-800">Descrição <span class="text-gray-500 font-normal">(opcional)</span></label>
        <input
          pInputText
          formControlName="description"
          placeholder="Nome interno da promoção"
          class="w-full"
        />
      </div>
      <div class="md:col-span-4 flex flex-col gap-1">
        <label class="block mb-1 font-medium text-gray-800">Ativa</label>
        <p-checkbox formControlName="active" [binary]="true" inputId="promo-active"></p-checkbox>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <label class="block mb-1 font-medium text-gray-800">Válida até <span class="text-red-500">*</span></label>
        <p-datepicker
          formControlName="validUntil"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          placeholder="Selecione a data"
          styleClass="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('validUntil') }"
        />
        <small *ngIf="isFieldInvalid('validUntil')" class="text-red-500">Data obrigatória</small>
      </div>
      <div>
        <label class="block mb-1 font-medium text-gray-800">Tipo de desconto <span class="text-red-500">*</span></label>
        <p-select
          formControlName="discountType"
          [options]="discountTypeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione"
          class="w-full"
          styleClass="w-full"
        ></p-select>
      </div>
      <div>
        <label class="block mb-1 font-medium text-gray-800">Valor do desconto <span class="text-red-500">*</span></label>
      <p-inputNumber
        formControlName="discountValue"
        [min]="0"
        [maxFractionDigits]="2"
        [minFractionDigits]="0"
        [suffix]="form.get('discountType')?.value === 0 ? ' %' : ''"
        [mode]="form.get('discountType')?.value === 1 ? 'currency' : 'decimal'"
        [currency]="form.get('discountType')?.value === 1 ? 'BRL' : undefined"
        locale="pt-BR"
        [inputStyle]="{ width: '100%' }"
        styleClass="w-full"
        [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('discountValue') }"
      />
      <small *ngIf="isFieldInvalid('discountValue')" class="text-red-500">Informe um valor válido</small>
      </div>
    </div>

    <div class="border-t border-gray-200 pt-6">
      <h3 class="text-sm font-semibold text-gray-800 mb-3">Escopo da promoção</h3>
      <p class="text-sm text-gray-600 mb-4">
        Informe um <strong>grupo</strong> (todos os produtos do grupo) e/ou <strong>produtos avulsos</strong> abaixo. Pelo menos um dos dois é obrigatório.
      </p>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div>
          <label class="block mb-1 font-medium text-gray-800">Grupo de produtos</label>
          <p-select
            formControlName="groupId"
            [options]="groups"
            optionLabel="description"
            optionValue="id"
            placeholder="Nenhum — apenas produtos da lista abaixo"
            [showClear]="true"
            [filter]="true"
            filterBy="description"
            class="w-full"
            styleClass="w-full"
          ></p-select>
          <small class="text-gray-500 text-xs mt-1 block">Opcional. Todos os produtos cadastrados nesse grupo entram na promoção.</small>
        </div>

        <div>
          <label class="block mb-1 font-medium text-gray-800">Adicionar produtos</label>
          <p-autocomplete
          [(ngModel)]="productPick"
          [ngModelOptions]="{ standalone: true }"
          [suggestions]="productSuggestions"
          (completeMethod)="onProductSearch($event)"
          (onSelect)="onProductSelected($event)"
          optionLabel="description"
          placeholder="Buscar por nome ou código..."
          [dropdown]="true"
          [forceSelection]="true"
          styleClass="w-full"
          class="w-full"
        >
          <ng-template let-item pTemplate="item">
            <div class="flex flex-col py-1">
              <span class="font-medium text-gray-900">{{ item.description }}</span>
              <span class="text-xs text-gray-500" *ngIf="item.code">Cód. {{ item.code }}</span>
            </div>
          </ng-template>
          </p-autocomplete>
          <small class="text-gray-500 text-xs mt-1 block">Busque e selecione para incluir. Os itens aparecem na lista abaixo.</small>
        </div>
      </div>

      <div
        *ngIf="addedProducts.length > 0"
        class="mt-2 rounded-lg border border-gray-200 bg-gray-50 divide-y divide-gray-200 max-h-56 lg:max-h-64 overflow-y-auto"
      >
        <div
          *ngFor="let row of addedProducts"
          class="flex items-center justify-between gap-3 px-3 py-2 text-sm bg-white first:rounded-t-lg last:rounded-b-lg"
        >
          <span class="text-gray-800 truncate">{{ productRowLabel(row) }}</span>
          <p-button
            type="button"
            icon="pi pi-times"
            [rounded]="true"
            [text]="true"
            severity="danger"
            (onClick)="removeProduct(row.id)"
            pTooltip="Remover"
          ></p-button>
        </div>
      </div>
      <p *ngIf="addedProducts.length === 0" class="text-sm text-gray-500 mt-3 italic">Nenhum produto avulso adicionado.</p>
    </div>

    <div class="flex gap-3">
      <button
        type="button"
        (click)="goBack()"
        class="border border-orange-500 text-orange-600 hover:bg-orange-50 px-4 py-2 rounded cursor-pointer"
      >
        Cancelar
      </button>
      <button class="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-md text-white cursor-pointer" type="submit">
        Salvar promoção
      </button>
    </div>
  </form>
    </div>
  </div>
</div>
